import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils';

interface FieldLabelProps {
    label: ReactNode;
    className?: string;
    htmlFor?: string;
    required?: boolean;
    htmlAttributes?: HTMLAttributes<HTMLLabelElement>;
}

export const FieldLabel = ({ label, required = false, htmlFor, className, htmlAttributes }: FieldLabelProps) => (
    <label
        className={cn('block text-xs font-medium text-gray-800', className)}
        htmlFor={htmlFor}
        {...htmlAttributes}
    >
        {label} {required && '*'}
    </label>
);
